<template>
    <div class="right author-right pt0 contract">
        <chapterTip v-if="signStauts&&(signStauts.code == 1||signStauts.code == 2)">
            <div slot="tip-name">{{$lang('authorCenter.stories.contractSign[0]')}}</div>
            <div slot="tip-con">
                <img :src="require(`@/assets/author/senLevel/ct-${$i18n.locale}-img.png`)" class="contract-img1"/>
            </div>
            <div slot="tip-btn">
                <!--审核中-->
                <el-button v-if="signStauts.code == 1" class="f16 font-MT" type="info" size="medium">{{$lang('authorCenter.stories.contractSign[1]')}}</el-button>
                <!--签约成功-->
                <el-button v-if="signStauts.code == 2" class="f16 font-MT" size="medium" type="warning" @click="getfinalFun()">{{$lang('authorCenter.stories.contractSign[2]')}}</el-button>
            </div>
        </chapterTip>
        <writerInfo
                class="contract-form mt0"
                v-if="signStautsFlag && lang === 'en_US' || lang === 'en_ID'"
                :type="2"
                :allowEditForm="allowEditForm"
                :countries="countries"
                :idCardType="idCardType"
                :reviewFlag="true"
                :contractTypeDesc="bookdetail.contractTypeDesc"
                :form="userAuthor"
                :signStauts="signStauts"
                @submitapply="submitapply"
        ></writerInfo>
        <chWriterInfo
          v-if="signStautsFlag && lang === 'zh_CN'"
          class="contract-form mt0"
          :type="1"
          :reviewFlag="false"
          :allowEditForm="allowEditForm"
          :countries="countries"
          :idCardType="idCardType"
          :form="userAuthor"
          @saveInfoFun="saveInfoFun"
        ></chWriterInfo>
        <!--合同下载-->
<!--        <div class="dialog-con" v-if="isShowPop">-->
<!--            <div class="dialog-con-bg"></div>-->
<!--            <div class="dialog-warp contract-warp" ref="addImage">-->
<!--                <div class="huaban-con">-->
<!--                    <div class="close fr mr20 mt20 f20 text-muted f-fwb" @click="closeFun"><i class="el-icon-close"></i></div>-->
<!--                    <vue-fabric-sketchpad :reviewFlag="true" :canvas-width="500" :canvas-height="300" placement="top" @composeImgFun="composeImgFun"/>-->
<!--&lt;!&ndash;                    <a :href="contractInfo" class="view-btn f18 text-default" target="_blank">&ndash;&gt;-->
<!--&lt;!&ndash;                        <el-button class="f16" type="warning" size="medium">{{$lang('authorCenter.stories.review')}}</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                    </a>&ndash;&gt;-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <!--不能签约-->
        <chapterTip v-if="!isSign">
            <div slot="tip-name">{{$lang('authorCenter.stories.contractSign[0]')}}</div>
            <div slot="tip-con">
                <img :src="require(`@/assets/author/senLevel/ct-${$i18n.locale}-img.png`)" class="contract-img1"/>
            </div>
            <div slot="tip-btn">
                <el-button class="f16 font-MT" :disabled="true" type="info" size="medium">{{$lang('authorCenter.stories.confirm')}}</el-button>
            </div>
        </chapterTip>
    </div>
</template>

<script>
    import {getsigninfo,signfinaldownload} from "apiurl/author";
    import {showLoading, hideLoading} from "@/utils/load";
    export default {
        name: "Contract",
        data () {
            return{
                userAuthor:{},
                countries: [],
                idCardType:[],
                allowEditForm: true,
                isSign: true,
                signStauts: null,
                /*合同*/
                isHuaban: false,
                signature: '',
                downimg: '',
                loading: false,
                contractInfo: '',
                lang: localStorage.getItem('language') || 'en_US',
            }
        },
        props: {
            bookdetail: Object
        },
        mounted () {
            this.getsigninfoFun()
        },
        computed: {
            signStautsFlag() {
                return this.signStauts && (this.signStauts.code == 0 || this.signStauts.code == -1|| this.signStauts.code == -2|| this.signStauts.code == -3);
            },
        },
        methods: {
            /*第一步：获取内容*/
            async getsigninfoFun () {
                let res = await getsigninfo(this.$route.params.id)
                console.log(res)
                if (res.code==1) {
                    this.isSign = true
                    let data = res.data
                    data.userAuthor.countryCode =  data.userAuthor.country&&data.userAuthor.country.code?data.userAuthor.country.code:''
                    data.userAuthor.targetOrgCode =  data.userAuthor.targetOrg&&data.userAuthor.targetOrg.org?data.userAuthor.targetOrg.org:''
                    this.countries = data.countries
                    this.idCardType = data.idCardType
                    this.allowEditForm = data.allowEdit
                    this.userAuthor=data.userAuthor
                    this.userAuthor.bookId=this.$route.params.id
                    this.signStauts = res.data.signStauts
                } else {
                    this.isSign = false
                    this.$faild('custom', res.message)
                }
            },
            /*第二步：预览合同*/
            submitapply(data) {
                this.$set(this.signStauts, 'code', data)
                this.closeFun()
            },
            /*下载最终合同*/
            getfinalFun () {
                let newWindow = window.open('', '_blank');
                showLoading()
                signfinaldownload(this.$route.params.id,{bookId: this.$route.params.id}).then(res=>{
                    hideLoading()
                    this.contractInfo = res.data
                    setTimeout(()=>{
                        newWindow.location = this.contractInfo
                    })
                })
            },
            // 关闭弹框
            closeFun () {
                this.getsigninfoFun()
                this.isHuaban = false
                this.$emit('changePop', false)
            },
            closesure (data) {
                this.isContract = data
                this.$emit('changePop', data)
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
    .contract-img1,.contract-finish-img{
        width: 100%;
    }
    .contract-form{
        padding-top: 35px;
        padding-bottom: 30px;
        margin: 0 50px;

    }
    .contract{
        /deep/.chapter-tip-btn,.down-contract{
            margin-left: 30px;
        }
        .upload-btn-info,.upload-btn-info .el-upload,
        .upload-btn-info .el-upload-input,.upload-btn-info .el-button{
            width: 230px;
            height: 42px;
        }
        /deep/.chapter-tip-btn{
            margin-top: 30px;
            padding-bottom: 50px;
        }
        /deep/.contract-dialog{
            /deep/.surepop{
                width: 566px;
                height: 441px;
                background-size: 566px 441px;
            }
        }
    }
    .contract-warp{
        position: absolute;
        width: 600px;
        height: 450px;
        overflow: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.1);
        .contract-down-btn{
            position: absolute;
            height: 78px;
            width: 100%;
            bottom: 0;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            /deep/.el-button--medium{
                width: 160px;
            }
        }
        .huaban-con{
            width: 100%;
            height: 100%;
            position: relative;
            /deep/.composeImg-btn{
                margin-right: 30px;
            }
            /deep/.board-box{
                left: 50%;
                transform: translateX(-50%);
                top: 50px;
            }
            .view-btn{
                text-decoration: underline;
                position: absolute;
                left: 80px;
                bottom: 24px;
                color: #48A2DF;
            }
        }
        @media (max-width:768px){
            .close{
                margin-right: 130px!important;
            }
            /*width:100%!important;*/
        }
    }
</style>
<style lang="scss">
    .contract-pop{
        background: rgba(0,0,0,0.8)!important;
        color: #fff;
        font-size: 16px!important;
        font-family: Arial!important;
        line-height: 26px!important;
        border-radius: BLACKCRAG!important;
        .popper__arrow,.popper__arrow::after{
            border-top-color: #000!important;
        }

    }
</style>
